import * as React from 'react';

export function AddToCart(props) {
  const isSold = props.isSold;
  const isDisabled = props.inCart || isSold;

  return (
    <div>
      <button
        className={`btn ${
          props.inCart ? 'btn-error' : props.isSold ? 'btn-sold' : 'btn-primary'
        }`}
        onClick={() => {
          if (!isDisabled) {
            props.handleClick(props.id);
          }
        }}
        disabled={isDisabled}
        style={
          isSold
            ? {
                backgroundColor: '#0e4f25',
                fontWeight: 'bold',
                color: '#ffffff',
              }
            : null
        }
      >
        {isSold ? (
          'SOLD'
        ) : props.inCart ? (
          <span className='text-green-500'>In Cart</span>
        ) : (
          'Add to Cart'
        )}
      </button>
    </div>
  );
}
